import { configureStore } from './configureStore';
import reducer from '../reducers/assignmentsActivity';

export function createStore(initialState) {
  return configureStore(initialState, reducer, { name: 'AssignmentsActivity' });
}
